import React from 'react';
import { Text, View } from '@react-pdf/renderer';

import { CONTRACT_DEADLINES } from '@/components/Contract/contractDeadlines';
import { Contract } from '@/types/ContractType';
import { styles } from '../style';

const NoticeAssesment = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>
        NOTICES, ASSESSMENTS, AND MUNICIPAL REQUIREMENTS
      </Text>

      <Text style={styles.text}>
        1. In the event any notices of public and/or private assessments are
        received after Seller has signed this Agreement and before settlement,
        Seller will within{' '}
        <Text style={styles.DangerText}>
          {CONTRACT_DEADLINES.noticeResponseDays}
        </Text>{' '}
        days of receiving the notices and/or assessments provide a copy of the
        notices and/or assessments to Buyer and will notify Buyer in writing
        that Seller will:
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          a.{' '}
          <Text style={styles.bold}>
            Fully comply with the notices and/or assessments, at Seller's
            expense, before settlement.
          </Text>{' '}
          If Seller fully complies with the notices and/or assessments, Buyer
          accepts the Property and agrees to the Release clause of this
          Agreement.
        </Text>

        <Text style={styles.listItem}>
          b.{' '}
          <Text style={styles.bold}>
            Not comply with the notices and/or assessments.
          </Text>{' '}
          If Seller chooses not to comply with the notices and/or assessments,
          or fails within the stated time to notify Buyer whether Seller will
          comply, Buyer will notify Seller in writing within{' '}
          <Text style={styles.DangerText}>
            {CONTRACT_DEADLINES.noticeResponseDays}
          </Text>{' '}
          days that Buyer will:
        </Text>

        <View style={styles.subList}>
          <Text style={styles.listItem}>
            i.{' '}
            <Text style={styles.bold}>
              Comply with the notices and/or assessments at Buyer's expense,
            </Text>{' '}
            accept the Property, and agree to the Release clause of this
            Agreement, OR
          </Text>

          <Text style={styles.listItem}>
            ii.{' '}
            <Text style={styles.DangerText}>
              Terminate this Agreement by written notice to Seller,
            </Text>{' '}
            with all deposit money returned to Buyer according to the terms of
            this Agreement.
          </Text>
        </View>

        <Text style={styles.listItem}>
          c. If Buyer fails to respond within{' '}
          <Text style={styles.DangerText}>
            {CONTRACT_DEADLINES.noticeResponseDays}
          </Text>{' '}
          days or fails to{' '}
          <Text style={styles.DangerText}>
            terminate this Agreement by written notice to Seller
          </Text>{' '}
          within that time, Buyer will accept the Property and agree to the
          Release clause of this Agreement.
        </Text>
      </View>

      <Text style={styles.text}>
        2. If required by law, within{' '}
        <Text style={styles.DangerText}>
          {CONTRACT_DEADLINES.municipalCertOrderDays}
        </Text>{' '}
        days from the Execution Date of this Agreement, but in no case later
        than{' '}
        <Text style={styles.DangerText}>
          {CONTRACT_DEADLINES.municipalCertDaysBeforeSettlement}
        </Text>{' '}
        days prior to Settlement Date, Seller will order at Seller's expense a
        certification from the appropriate municipal department(s) disclosing
        notice of any uncorrected violations of zoning, housing, building,
        safety or fire ordinances and/or a certificate permitting occupancy of
        the Property. If Buyer receives a notice of any required
        repairs/improvements, Buyer will promptly deliver a copy of the notice
        to Seller.
      </Text>

      <Text style={styles.text}>
        3. Within{' '}
        <Text style={styles.DangerText}>
          {CONTRACT_DEADLINES.noticeResponseDays}
        </Text>{' '}
        days of receiving notice from the municipality that repairs/improvements
        are required, Seller will deliver a copy of the notice to Buyer and
        notify Buyer in writing that Seller will:
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          a. Make the required repairs/improvements to the satisfaction of the
          municipality. If Seller makes the required repairs/improvements, Buyer
          accepts the Property and agrees to the Release clause of this
          Agreement.
        </Text>

        <Text style={styles.listItem}>
          b. Not make the required repairs/improvements. If Seller chooses not
          to make the required repairs/improvements, Buyer will notify Seller in
          writing within{' '}
          <Text style={styles.ClauseText}>
            {CONTRACT_DEADLINES.noticeResponseDays}
          </Text>{' '}
          days that Buyer will:
        </Text>

        <View style={styles.subList}>
          <Text style={styles.listItem}>
            i. Accept a temporary access certificate or temporary use and
            occupancy certificate, agree to the Release clause of this Agreement
            and make the repairs at Buyer's expense after settlement
          </Text>

          <Text style={styles.listItem}>
            ii.{' '}
            <Text style={styles.DangerText}>
              Terminate this Agreement by written notice to Seller
            </Text>{' '}
            with all deposit money returned to Buyer according to the terms of
            this Agreement.
          </Text>
        </View>

        <Text style={styles.listItem}>
          c. If Buyer fails to respond within{' '}
          <Text style={styles.DangerText}>
            {CONTRACT_DEADLINES.noticeResponseDays}
          </Text>{' '}
          days or <Text style={styles.DangerText}>fails to terminate</Text> this
          Agreement by written notice to Seller within that time, Buyer will
          accept the Property and agree to the Release clause of this Agreement,
          and Buyer accepts the responsibility to perform the
          repairs/improvements according to the terms of the notice provided by
          the municipality.
        </Text>
      </View>

      <Text style={styles.text}>
        4. If repairs/improvements are required and Seller fails to provide a
        copy of the notice to Buyer as required in this paragraph, Seller will
        perform all repairs/improvements as required by the notice at Seller's
        expense. This clause will survive settlement.
      </Text>
    </View>
  );
};

export default NoticeAssesment;
